module.exports = __webpack_public_path__ + "static/img/des.aba0a31.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/team/des.png
// module id = oxph
// module chunks = 7